import React from 'react';
import { StepPage } from "../../components/StepPage";
import { COBStep, getNextStepButtonText, getStepName } from "../ClientOnboarding.utils";
import { useCobConfig } from "../CobConfigContext";
import VideoPlayer from "../../../components/VideoPlayer/VideoPlayer";
import { videoUrl } from "../../../models/intro-video";
import { Button } from 'seagull';
const IntroVideoStep = _ref => {
  let {
    onDone,
    onBack
  } = _ref;
  const {
    relationship
  } = useCobConfig();
  const {
    introVideo
  } = relationship;
  const testId = 'intro-video-step';
  const url = introVideo && videoUrl(introVideo);
  if (!url) {
    throw new Error('Intro Video does not have URL');
  }
  return /*#__PURE__*/React.createElement(StepPage, {
    header: getStepName(COBStep.introVideo, relationship),
    testid: testId,
    primaryBtn: /*#__PURE__*/React.createElement(Button, {
      "data-testid": "".concat(testId, "-next-btn"),
      onClick: onDone
    }, getNextStepButtonText(COBStep.introVideo, relationship)),
    backBtnTestid: "".concat(testId, "-back-btn"),
    onBackBtnClick: onBack
  }, /*#__PURE__*/React.createElement("div", {
    "data-testid": "".concat(testId, "-video")
  }, /*#__PURE__*/React.createElement(VideoPlayer, {
    url: url,
    height: '100%'
  })));
};
export default IntroVideoStep;